export const setHours = (value, minutesToAdd) => {
  const now = new Date();
  const date = new Date(value);
  const addMinutes = minutesToAdd || 0;

  return date.setHours(now.getHours(), now.getMinutes() + addMinutes, now.getSeconds());
};
